import React from 'react';
import RelaySummary from './Search';
import RelayDetails from './RelayDetails';
import Container from 'react-bootstrap/Container';
import './scss/custom.scss';
import './App.css';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import {
  HashRouter as Router,
  Switch,
  Route,
  Link,
  useParams
} from "react-router-dom";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      'limit': 15,
    };
    this.handleLimitChange = this.handleLimitChange.bind(this);
    this.handleSearchQueryChange = this.handleSearchQueryChange.bind(this);
    this.onSearchQueryChange = this.onSearchQueryChange.bind(this);
  }

  handleLimitChange(limit) {
    this.setState({
      'limit': limit,
    });
  }

  handleSearchQueryChange(query) {
    this.setState({
      'search': query,
    });
  }

  onSearchQueryChange(event) {
    this.handleSearchQueryChange(event.target.value);
    event.preventDefault();
  }

  render() {
    return (
      <Router>
      <Navbar variant="dark" bg="dark" expand="md" style={{'margin-bottom': '1em'}}>
          <Container>
          <Navbar.Brand as={Link} to="/">irl's Relay Search</Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link as={Link} to="/">Home</Nav.Link>
              <Nav.Link as={Link} to="/search">Search</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          </Container>
      </Navbar>
      <Switch>
      <Route path="/search/:query?">
        <RelaySearchView />
      </Route>
      <Route path="/details/:query?">
        <RelayDetailsView />
      </Route>
      <Route path="/">
        <RelaySearchView />
      </Route>
      </Switch>
      </Router>
    );
  }
}

function RelaySearchView(props) {
  let { query } = useParams();
  return <RelaySummary search={query} limit={10} />;
}

function RelayDetailsView(props) {
  let { query } = useParams();
  return <RelayDetails search={query} />;
}

export default App;
